import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteAPI, getAPI, postAPI, putAPI } from "../service/http-service";
import {
  AdminSettingsEndpoint,
  FeedbackEndpoint,
} from "../service/endpointConfig/AdminSettingsEndpoint";

export interface AdminSettingsProps {
  id: number;
  roleName: string;
  roleDescription: string;
  displayInFranchisee: boolean;
  active: boolean;
}

let initialState: any = {
  adminSettingsResponse: {},
};

//Get User Role API call
export const AdminSettingsList = createAsyncThunk(
  "master/adminSettings",
  async (AdminSettingsRequestData: any) => {
    try {
      let response;
      switch (AdminSettingsRequestData.apiAction) {
        case "list":
          response = await getAPI(AdminSettingsEndpoint.adminSettings);
          break;
        case "listById":
          response = await getAPI(
            `${AdminSettingsEndpoint.adminSettings}/${AdminSettingsRequestData.formValues}`
          );
          break;
        case "create":
          response = await postAPI(
            AdminSettingsEndpoint.createBulkMessages,
            AdminSettingsRequestData.formValues
          );
          break;
        case "update":
          response = await putAPI(
            AdminSettingsEndpoint.adminSettings,
            AdminSettingsRequestData.formValues
          );
          break;
        case "swap":
          response = await putAPI(
            AdminSettingsEndpoint.createBulkMessages,
            AdminSettingsRequestData.formValues
          );
          break;
        case "delete":
          response = await deleteAPI(
            `${AdminSettingsEndpoint.adminSettings}/${AdminSettingsRequestData.formValues}`
          );
          break;
        case "deleteAll":
          response = await deleteAPI(
            `${AdminSettingsEndpoint.adminSettings}?${AdminSettingsRequestData.requestParams}`
          );
          break;
        case "createFeedback":
          response = await postAPI(
            FeedbackEndpoint.feedback,
            AdminSettingsRequestData.formValues
          );
          break;
        case "loginImgUpload":
          response = await postAPI(
            AdminSettingsEndpoint.fileUpload,
            AdminSettingsRequestData.formValues
          );
          break;
        case "myProfileUpload":
          response = await postAPI(
            `${AdminSettingsEndpoint.fileUpload}/myprofile/${AdminSettingsRequestData.id}`,
            AdminSettingsRequestData.formValues
          );
          break;
        case "updateFeedback":
          response = await putAPI(
            FeedbackEndpoint.feedback,
            AdminSettingsRequestData.formValues
          );
          break;
        case "feedbackList":
          response = await getAPI(`${FeedbackEndpoint.feedback}`);
          break;
      }
      return response;
    } catch (err) {
      return err;
    }
  }
);

const adminSettingsSlice = createSlice({
  name: "adminSettings",
  initialState,
  reducers: {
    addObj: (state, action: any) => {
      state.entity.push({ success: false });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(AdminSettingsList.fulfilled, (state, action) => {
      state.adminSettingsResponse = action.payload;
    });
    builder.addCase(AdminSettingsList.rejected, (state, action) => {
      if (action.payload) {
        state.entity = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const adminSettingsReducer = adminSettingsSlice.reducer;
export default adminSettingsReducer;
